
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("k9zbN", function(module, exports) {
$parcel$export(module.exports, "GlobalCreateContentPopover", () => (parcelRequire("aQZ08")).GlobalCreateContentPopover);
$parcel$export(module.exports, "GlobalCreateContentButton", () => (parcelRequire("gsXbX")).GlobalCreateContentButton);
$parcel$export(module.exports, "ContextualCreateContentPopover", () => (parcelRequire("2to2n")).ContextualCreateContentPopover);
$parcel$export(module.exports, "contextualCreateContentIconSVGColor", () => (parcelRequire("cDCEW")).contextualCreateContentIconSVGColor);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $aQZ08 = parcelRequire("aQZ08");


var $gsXbX = parcelRequire("gsXbX");


var $2to2n = parcelRequire("2to2n");


var $cDCEW = parcelRequire("cDCEW");


});

parcelRegister("de2j9", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");

const $da4a5d353aff754e$var$isOnEditorPageRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.EDIT_PAGE_V2).name || routeName === (0, $1NBp8.EDIT_BLOG_V2).name || routeName === (0, $1NBp8.EDIT_PAGE_EMBED).name || routeName === (0, $1NBp8.COMPANY_HUB_EDIT).name || routeName === (0, $1NBp8.HUB_EDIT).name || routeName === (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name || routeName === (0, $1NBp8.SPACE_SETTINGS_AGENT_CONTEXT).name
};
const $da4a5d353aff754e$export$90b90ac8ec152a49 = ()=>{
    return (0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
};
module.exports["useIsEditorPage"] = $da4a5d353aff754e$export$90b90ac8ec152a49;

});

parcelRegister("7EIq6", function(module, exports) {

var $dd33Q = parcelRequire("dd33Q");


var $jtuBN = parcelRequire("jtuBN");


var $iLgzu = parcelRequire("iLgzu");

const $649b778bbd82b1bb$var$useSpaceEnabledContentTypesQuery = (0, $dd33Q.default);
function $649b778bbd82b1bb$export$1defcb29347f9ac6(spaceKey) {
    const { data: defaultSpaceKeyData, loading: isDefaultSpaceKeyLoading } = (0, $iLgzu.useExperimentalPromotedSpacesQuery)({
        skip: spaceKey !== undefined,
        variables: {
            promotedSpacesLimit: 1,
            otherSpacesLimit: 1,
            promotedSpaceKey: null
        }
    });
    const spaceEnabledContentTypesQueryOptions = {
        errorPolicy: 'all',
        skip: !spaceKey && !defaultSpaceKeyData,
        variables: {
            spaceKey: spaceKey || defaultSpaceKeyData?.experimentalPromotedSpaces?.nodes?.[0]?.id
        }
    };
    const { data: enabledContentTypesData, loading: isAnyContentTypesLoading } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)($649b778bbd82b1bb$var$useSpaceEnabledContentTypesQuery, spaceEnabledContentTypesQueryOptions);
    const enabledContentTypes = enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes;
    const hasUndefinedContentTypes = enabledContentTypes === undefined || Object.values(enabledContentTypes).some((type)=>type === undefined);
    const isLoading = isDefaultSpaceKeyLoading || isAnyContentTypesLoading || hasUndefinedContentTypes;
    return {
        isCreateWhiteboardEnabled: Boolean(enabledContentTypes?.isWhiteboardsEnabled),
        isCreateBlogEnabled: Boolean(enabledContentTypes?.isBlogsEnabled),
        isCreateDatabaseEnabled: Boolean(enabledContentTypes?.isDatabasesEnabled),
        isCreateSmartLinkEnabled: Boolean(enabledContentTypes?.isEmbedsEnabled),
        isCreateLiveDocEnabled: Boolean(enabledContentTypes?.isLivePagesEnabled),
        isCreateFolderEnabled: Boolean(enabledContentTypes?.isFoldersEnabled),
        isCreateSlidesEnabled: Boolean(enabledContentTypes?.isSlidesEnabled),
        isLoading: isLoading
    };
}
module.exports["useSpaceEnabledContentTypes"] = $649b778bbd82b1bb$export$1defcb29347f9ac6;

});

parcelRegister("dd33Q", function(module, exports) {
/**
 * @generated SignedSource<<79c814000abc51a87825021048515fd1>>
 * @relayHash 10a6e74201e75f7fd05257845e870e22
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5f78c38bf43db12554ba0f37ad39b4afd115d6ef16213fadbd51e8708bc161d2
const $b17ca59e188f1f50$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "SpaceTypeSettings",
                    "kind": "LinkedField",
                    "name": "spaceTypeSettings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "EnabledContentTypes",
                            "kind": "LinkedField",
                            "name": "enabledContentTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isBlogsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isDatabasesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isEmbedsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isLivePagesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isSlidesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isWhiteboardsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isFoldersEnabled"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceEnabledContentTypesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceEnabledContentTypesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "10a6e74201e75f7fd05257845e870e22",
            "id": "5f78c38bf43db12554ba0f37ad39b4afd115d6ef16213fadbd51e8708bc161d2",
            "metadata": {},
            "name": "useSpaceEnabledContentTypesQuery",
            "operationKind": "query",
            "text": "query useSpaceEnabledContentTypesQuery($spaceKey:String){space(key:$spaceKey){id,key,spaceTypeSettings{enabledContentTypes{isBlogsEnabled,isDatabasesEnabled,isEmbedsEnabled,isLivePagesEnabled,isSlidesEnabled,isWhiteboardsEnabled,isFoldersEnabled}}}}"
        }
    };
}();
$b17ca59e188f1f50$var$node.hash = "031eb89bf77537fd501cf18345136db8";
var $b17ca59e188f1f50$export$2e2bcd8739ae039 = $b17ca59e188f1f50$var$node;
module.exports["default"] = $b17ca59e188f1f50$export$2e2bcd8739ae039;

});

parcelRegister("eVXGa", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $1337beb96693807c$var$isAllowedToCreate = (accessStatus)=>accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
const $1337beb96693807c$export$1060ff57674ca8ef = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $1337beb96693807c$var$isAllowedToCreate(accessStatus);
};
module.exports["useIsAllowedToCreateWhiteboard"] = $1337beb96693807c$export$1060ff57674ca8ef;

});

parcelRegister("j2wXr", function(module, exports) {

let $ddc7c4f2d18c168b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ddc7c4f2d18c168b$var$load("6wr18"),
    $ddc7c4f2d18c168b$var$load("iMSgb"),
    $ddc7c4f2d18c168b$var$load("hLjS5"),
    $ddc7c4f2d18c168b$var$load("7bkye"),
    $ddc7c4f2d18c168b$var$load("48rvp"),
    $ddc7c4f2d18c168b$var$load("bAAhx"),
    $ddc7c4f2d18c168b$var$load("hhss7"),
    $ddc7c4f2d18c168b$var$load("ffEVr"),
    $ddc7c4f2d18c168b$var$load("7EorR"),
    $ddc7c4f2d18c168b$var$load("dnVDi")
]).then(()=>parcelRequire('ePUmE'));

});

parcelRegister("fZHGM", function(module, exports) {

let $ba4e713ea8068870$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ba4e713ea8068870$var$load("7gkvG"),
    $ba4e713ea8068870$var$load("aMRFX"),
    $ba4e713ea8068870$var$load("396ld"),
    $ba4e713ea8068870$var$load("6wr18"),
    $ba4e713ea8068870$var$load("iAqyW"),
    $ba4e713ea8068870$var$load("3CBDb"),
    $ba4e713ea8068870$var$load("lnk1B"),
    $ba4e713ea8068870$var$load("7PNQN"),
    $ba4e713ea8068870$var$load("4hsy8"),
    $ba4e713ea8068870$var$load("gy5DL"),
    $ba4e713ea8068870$var$load("7QQL7"),
    $ba4e713ea8068870$var$load("hOaAV"),
    $ba4e713ea8068870$var$load("lFAez"),
    $ba4e713ea8068870$var$load("1qlDN"),
    $ba4e713ea8068870$var$load("1yVM6"),
    $ba4e713ea8068870$var$load("cEqm7"),
    $ba4e713ea8068870$var$load("6XCf4"),
    $ba4e713ea8068870$var$load("3KVI3"),
    $ba4e713ea8068870$var$load("9DBoM"),
    $ba4e713ea8068870$var$load("7EorR"),
    $ba4e713ea8068870$var$load("ffEVr"),
    $ba4e713ea8068870$var$load("hhss7"),
    $ba4e713ea8068870$var$load("aRRyd"),
    $ba4e713ea8068870$var$load("dwffN")
]).then(()=>parcelRequire('bvmt1'));

});

parcelRegister("2to2n", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $lGgRw = parcelRequire("lGgRw");


var $4kfV4 = parcelRequire("4kfV4");


var $inPa6 = parcelRequire("inPa6");


var $6f0Oj = parcelRequire("6f0Oj");


var $ecnYn = parcelRequire("ecnYn");


var $9wGTI = parcelRequire("9wGTI");


var $56QzY = parcelRequire("56QzY");


var $lqy4C = parcelRequire("lqy4C");


var $de2j9 = parcelRequire("de2j9");


var $7xVCs = parcelRequire("7xVCs");


var $luv00 = parcelRequire("luv00");


var $6adZX = parcelRequire("6adZX");


var $cbBHq = parcelRequire("cbBHq");


var $7EIq6 = parcelRequire("7EIq6");


var $6PMed = parcelRequire("6PMed");


var $cDCEW = parcelRequire("cDCEW");


var $jmjWc = parcelRequire("jmjWc");


const $c577bd07d81ca8a9$export$bcd38c5b8189fb61 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "F0d7H",
    name: "ContextualCreateContentPopoverMenuLoader",
    loader: async ()=>(await (parcelRequire("hEnjc"))).ContextualCreateContentPopoverMenu
});









var $aXWIB = parcelRequire("aXWIB");


var $g5gZt = parcelRequire("g5gZt");


var $9x2sR = parcelRequire("9x2sR");


var $jh864 = parcelRequire("jh864");

const $8c3f789353c0f876$var$addIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
    label: "",
    color: "currentColor",
    size: "small"
});
const $8c3f789353c0f876$export$eabe3aa0b599cb62 = (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { onClick: onClick, href: href } = t0;
    if (href) {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $8c3f789353c0f876$var$i18n.create);
            $[0] = t1;
        } else t1 = $[0];
        let t2;
        if ($[1] !== href || $[2] !== onClick) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
                onClick: onClick,
                elemBefore: $8c3f789353c0f876$var$addIcon,
                href: href,
                testId: "tree-create-content-button"
            }, t1);
            $[1] = href;
            $[2] = onClick;
            $[3] = t2;
        } else t2 = $[3];
        return t2;
    }
    let t1;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $8c3f789353c0f876$var$i18n.create);
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== onClick) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jh864.ButtonMenuItem), {
            onClick: onClick,
            elemBefore: $8c3f789353c0f876$var$addIcon,
            testId: "tree-create-content-button"
        }, t1);
        $[5] = onClick;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
};
const $8c3f789353c0f876$var$i18n = (0, $aXWIB.defineMessages)({
    create: {
        id: "create-blank-fabric-page.create-content-menu-item.create",
        defaultMessage: "Create"
    }
});


// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0a7a1bff19d06ba1$var$TriggerContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_80om73ad",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $0a7a1bff19d06ba1$var$customPopupContainerStyles = (0, $ecnYn.xcss)({
    zIndex: 'modal',
    backgroundColor: 'elevation.surface.overlay',
    boxShadow: 'elevation.shadow.overlay',
    borderRadius: 'radius.small',
    ':focus': {
        outline: 'none'
    }
});
const $0a7a1bff19d06ba1$var$CustomPopupContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, popupRef)=>{
    const $ = (0, $frIzR.c)(9);
    let children;
    let dataTestId;
    let props;
    if ($[0] !== t0) {
        ({ children: children, "data-testid": dataTestId, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = dataTestId;
        $[3] = props;
    } else {
        children = $[1];
        dataTestId = $[2];
        props = $[3];
    }
    let t1;
    if ($[4] !== children || $[5] !== dataTestId || $[6] !== popupRef || $[7] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            testId: dataTestId,
            ...props,
            ref: popupRef,
            xcss: $0a7a1bff19d06ba1$var$customPopupContainerStyles
        }, children);
        $[4] = children;
        $[5] = dataTestId;
        $[6] = popupRef;
        $[7] = props;
        $[8] = t1;
    } else t1 = $[8];
    return t1;
});
const $0a7a1bff19d06ba1$export$79699783f82a969e = (t0)=>{
    const $ = (0, $frIzR.c)(47);
    const { closeAllHoverPageCards: closeAllHoverPageCards, isContextualCreateFocused: isContextualCreateFocused, setIsContextualCreateFocused: setIsContextualCreateFocused, spaceKey: spaceKey, parentId: parentId, source: source, displayTitle: displayTitle, rootCreateButtonStyling: t1, shouldShowPopup: shouldShowPopup, setShouldShowPopup: setShouldShowPopup, isTreeItem: isTreeItem, onItemClick: onItemClick, shouldRenderToParent: shouldRenderToParent, hideFolder: hideFolder, contentType: contentType, renderTrigger: renderTrigger } = t0;
    const rootCreateButtonStyling = t1 === undefined ? false : t1;
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    let t2;
    if ($[0] !== shouldShowPopup) {
        t2 = ()=>!!shouldShowPopup;
        $[0] = shouldShowPopup;
        $[1] = t2;
    } else t2 = $[1];
    const [isOpen, setIsOpen] = (0, $42omo.useState)(t2);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { closeFlyout: closeFlyout } = (0, $6adZX.useFlyoutActions)();
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            source: "page-tree-contextual-create"
        };
        $[2] = t3;
    } else t3 = $[2];
    const { enforceStorageLimit: enforceStorageLimit } = (0, $lqy4C.useHardStorageEnforcement)(t3);
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const preloadCreationMenuData = (0, $6PMed.usePreloadCreationMenuData)();
    const preloadSmartCreationModal = (0, $cbBHq.usePreloadSmartCreationModal)();
    let t4;
    if ($[3] !== preloadCreationMenuData || $[4] !== preloadSmartCreationModal) {
        t4 = ()=>{
            preloadCreationMenuData();
            preloadSmartCreationModal();
            (0, $c577bd07d81ca8a9$export$bcd38c5b8189fb61).preload();
        };
        $[3] = preloadCreationMenuData;
        $[4] = preloadSmartCreationModal;
        $[5] = t4;
    } else t4 = $[5];
    const preloadCreationMenu = t4;
    const stopEvents = $0a7a1bff19d06ba1$var$_temp;
    let t5;
    if ($[6] !== closeFlyout) {
        t5 = (event_0)=>{
            closeFlyout();
            stopEvents(event_0);
        };
        $[6] = closeFlyout;
        $[7] = t5;
    } else t5 = $[7];
    const handleOnClick = t5;
    let t6;
    if ($[8] !== closeAllHoverPageCards || $[9] !== createAnalyticsEvent || $[10] !== isContextualCreateFocused || $[11] !== isOnEditRoute || $[12] !== isOpen || $[13] !== setIsContextualCreateFocused || $[14] !== setShouldShowPopup || $[15] !== source) {
        t6 = ()=>{
            setIsContextualCreateFocused?.(!isContextualCreateFocused);
            closeAllHoverPageCards?.();
            setIsOpen(!isOpen);
            setShouldShowPopup?.(!isOpen);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "contextualCreateButton",
                    actionSubjectId: source,
                    source: "containerNavigation",
                    attributes: {
                        navdexPointType: (0, $56QzY.START),
                        isOnEditRoute: isOnEditRoute
                    }
                }
            }).fire();
        };
        $[8] = closeAllHoverPageCards;
        $[9] = createAnalyticsEvent;
        $[10] = isContextualCreateFocused;
        $[11] = isOnEditRoute;
        $[12] = isOpen;
        $[13] = setIsContextualCreateFocused;
        $[14] = setShouldShowPopup;
        $[15] = source;
        $[16] = t6;
    } else t6 = $[16];
    const onTriggerClick = t6;
    let t7;
    if ($[17] !== setIsContextualCreateFocused || $[18] !== setShouldShowPopup) {
        t7 = ()=>{
            const activeEle = document.activeElement;
            activeEle?.blur();
            setIsOpen(false);
            setShouldShowPopup?.(false);
            setTimeout(()=>{
                setIsContextualCreateFocused?.(false);
            }, 0);
        };
        $[17] = setIsContextualCreateFocused;
        $[18] = setShouldShowPopup;
        $[19] = t7;
    } else t7 = $[19];
    const onCloseHandler = t7;
    const { isCreateWhiteboardEnabled: isCreateWhiteboardEnabled, isCreateDatabaseEnabled: isCreateDatabaseEnabled, isCreateSmartLinkEnabled: isCreateSmartLinkEnabled, isCreateLiveDocEnabled: isCreateLiveDocEnabled, isCreateFolderEnabled: isCreateFolderEnabled, isCreateSlidesEnabled: isCreateSlidesEnabled } = (0, $7EIq6.useSpaceEnabledContentTypes)(spaceKey);
    let t8;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = [
            (0, $7xVCs.PageTreeStateUpdater)
        ];
        $[20] = t8;
    } else t8 = $[20];
    let t9;
    if ($[21] !== contentType || $[22] !== displayTitle || $[23] !== enforceStorageLimit || $[24] !== handleOnClick || $[25] !== hideFolder || $[26] !== isContextualCreateFocused || $[27] !== isCreateDatabaseEnabled || $[28] !== isCreateFolderEnabled || $[29] !== isCreateLiveDocEnabled || $[30] !== isCreateSlidesEnabled || $[31] !== isCreateSmartLinkEnabled || $[32] !== isCreateWhiteboardEnabled || $[33] !== isOpen || $[34] !== isTreeItem || $[35] !== onCloseHandler || $[36] !== onItemClick || $[37] !== onTriggerClick || $[38] !== parentId || $[39] !== preloadCreationMenu || $[40] !== renderTrigger || $[41] !== rootCreateButtonStyling || $[42] !== shouldRenderToParent || $[43] !== source || $[44] !== spaceKey || $[45] !== ssrPlaceholderIdProp) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t8
        }, (pageStateUpdater)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, shouldRenderToParent && isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4kfV4.default), {
                testId: "contextual-create-blanket",
                isTinted: false,
                onBlanketClicked: onCloseHandler
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
                isOpen: isOpen,
                onClose: onCloseHandler,
                placement: "bottom-start",
                offset: [
                    0,
                    8
                ],
                content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c577bd07d81ca8a9$export$bcd38c5b8189fb61), {
                        source: source,
                        parentId: parentId,
                        isCreateWhiteboardEnabled: isCreateWhiteboardEnabled,
                        isCreateDatabaseEnabled: isCreateDatabaseEnabled,
                        isCreateSmartLinkEnabled: isCreateSmartLinkEnabled,
                        isCreateLiveDocEnabled: isCreateLiveDocEnabled,
                        isCreateFolderEnabled: isCreateFolderEnabled && !hideFolder,
                        isCreateSlidesEnabled: isCreateSlidesEnabled,
                        onCloseMenu: onCloseHandler,
                        pageStateUpdater: pageStateUpdater,
                        onItemClick: onItemClick,
                        parentTitle: displayTitle,
                        parentContentType: contentType
                    }),
                popupComponent: shouldRenderToParent ? $0a7a1bff19d06ba1$var$CustomPopupContainer : undefined,
                zIndex: shouldRenderToParent && (0, $9wGTI.fg)("platform-dst-motion-uplift-popup") ? 510 : undefined,
                trigger: (triggerProps)=>{
                    let triggerContent;
                    if (isTreeItem) triggerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", triggerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8c3f789353c0f876$export$eabe3aa0b599cb62), {
                        onClick: enforceStorageLimit(onTriggerClick)
                    }));
                    else if (renderTrigger) triggerContent = renderTrigger({
                        onClick: enforceStorageLimit(onTriggerClick),
                        triggerProps: triggerProps
                    });
                    else triggerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cDCEW.ContextualCreateContentButton), {
                        onClick: enforceStorageLimit(onTriggerClick),
                        triggerProps: triggerProps,
                        isContextualCreateFocused: isContextualCreateFocused,
                        isOpen: isOpen,
                        spaceKey: spaceKey,
                        rootCreateButtonStyling: rootCreateButtonStyling,
                        displayTitle: displayTitle
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0a7a1bff19d06ba1$var$TriggerContainer, {
                        onClick: handleOnClick,
                        onFocus: stopEvents,
                        onBlur: stopEvents,
                        "data-vc": "contextual-create-content-popover",
                        ...ssrPlaceholderIdProp
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                        onMouseEnter: preloadCreationMenu,
                        onFocus: preloadCreationMenu
                    }, triggerContent), !shouldRenderToParent && isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4kfV4.default), {
                        testId: "contextual-create-blanket",
                        isTinted: false,
                        onBlanketClicked: onCloseHandler
                    }));
                },
                shouldRenderToParent: shouldRenderToParent,
                testId: "contextual-create-popover"
            })));
        $[21] = contentType;
        $[22] = displayTitle;
        $[23] = enforceStorageLimit;
        $[24] = handleOnClick;
        $[25] = hideFolder;
        $[26] = isContextualCreateFocused;
        $[27] = isCreateDatabaseEnabled;
        $[28] = isCreateFolderEnabled;
        $[29] = isCreateLiveDocEnabled;
        $[30] = isCreateSlidesEnabled;
        $[31] = isCreateSmartLinkEnabled;
        $[32] = isCreateWhiteboardEnabled;
        $[33] = isOpen;
        $[34] = isTreeItem;
        $[35] = onCloseHandler;
        $[36] = onItemClick;
        $[37] = onTriggerClick;
        $[38] = parentId;
        $[39] = preloadCreationMenu;
        $[40] = renderTrigger;
        $[41] = rootCreateButtonStyling;
        $[42] = shouldRenderToParent;
        $[43] = source;
        $[44] = spaceKey;
        $[45] = ssrPlaceholderIdProp;
        $[46] = t9;
    } else t9 = $[46];
    return t9;
};
function $0a7a1bff19d06ba1$var$_temp(event) {
    event.stopPropagation();
    event.preventDefault();
}
module.exports["ContextualCreateContentPopover"] = $0a7a1bff19d06ba1$export$79699783f82a969e;

});

parcelRegister("lqy4C", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4c1VG = parcelRequire("4c1VG");


var $alLTz = parcelRequire("alLTz");


var $cLhhP = parcelRequire("cLhhP");

const $047fd93b8f400f5d$export$5419ac0b96bac54b = ({ source: source })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    const { isStorageEnforcementGracePeriodComplete: isStorageEnforcementGracePeriodComplete } = (0, $4c1VG.useGetCurrentStorageUsage)({
        skip: !isEligibleUser
    });
    const { showBlockCreateModal: showBlockCreateModal } = (0, $cLhhP.useBlockCreateModalActions)();
    const shouldBlockCreate = isEligibleUser && Boolean(isStorageEnforcementGracePeriodComplete);
    const enforceStorageLimit = (0, $42omo.useCallback)((callback)=>(...args)=>{
            if (shouldBlockCreate) {
                // If the callback is a DOM event (e.g. click, keydown/keyup)
                // handler, prevent the default action (e.g. navigating to an href):
                const event = args?.[0];
                if (event && typeof event.preventDefault === 'function') event.preventDefault();
                experienceTracker.start({
                    name: (0, $irVI7.ONBOARDING_STORAGE_ENFORCEMENT_BLOCK_CREATE_MODAL)
                });
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'render',
                        actionSubject: 'hardStorageEnforcement',
                        actionSubjectId: 'enforceStorageLimit',
                        source: source || 'onboarding'
                    }
                }).fire();
                showBlockCreateModal(source);
                return;
            }
            return callback.apply(undefined, args);
        }, [
        createAnalyticsEvent,
        experienceTracker,
        shouldBlockCreate,
        showBlockCreateModal,
        source
    ]);
    return {
        shouldBlockCreate: shouldBlockCreate,
        enforceStorageLimit: enforceStorageLimit
    };
};
module.exports["useHardStorageEnforcement"] = $047fd93b8f400f5d$export$5419ac0b96bac54b;

});

parcelRegister("4c1VG", function(module, exports) {

var $1hmAp = parcelRequire("1hmAp");


var $jMyy4 = parcelRequire("jMyy4");

const $1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery = (0, $1hmAp.default);
const $1f652a8c0a42982a$export$8bf54c39c48ff2d2 = ({ skip: skip } = {})=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery, {
        skip: skip,
        __callerPackage__: "@confluence/storage-enforcement"
    });
    return {
        currentUsage: data?.storage?.bytesUsed ?? 0,
        isStorageEnforcementGracePeriodComplete: data?.storage?.isStorageEnforcementGracePeriodComplete,
        gracePeriodEndDate: data?.storage?.gracePeriodEndDate,
        loading: loading,
        error: error
    };
};
module.exports["useGetCurrentStorageUsage"] = $1f652a8c0a42982a$export$8bf54c39c48ff2d2;

});

parcelRegister("1hmAp", function(module, exports) {
/**
 * @generated SignedSource<<dc205b784e864c4042673f60370ebfb9>>
 * @relayHash 70e80297d041fb31c0639d661a01c799
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54
const $dc4c6b557b36d823$var$node = function() {
    var v0 = [
        {
            "alias": "storage",
            "concreteType": "ConfluenceStorage",
            "kind": "LinkedField",
            "name": "confluence_storage",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "bytesUsed"
                },
                {
                    "kind": "ScalarField",
                    "name": "isStorageEnforcementGracePeriodComplete"
                },
                {
                    "kind": "ScalarField",
                    "name": "gracePeriodEndDate"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "70e80297d041fb31c0639d661a01c799",
            "id": "6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54",
            "metadata": {},
            "name": "useGetCurrentStorageUsageQuery",
            "operationKind": "query",
            "text": "query useGetCurrentStorageUsageQuery{storage:confluence_storage{bytesUsed,isStorageEnforcementGracePeriodComplete,gracePeriodEndDate}}"
        }
    };
}();
$dc4c6b557b36d823$var$node.hash = "41d2bf41d832c3866355b26b49942948";
var $dc4c6b557b36d823$export$2e2bcd8739ae039 = $dc4c6b557b36d823$var$node;
module.exports["default"] = $dc4c6b557b36d823$export$2e2bcd8739ae039;

});

parcelRegister("alLTz", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");

const $2f3a7af74886cca0$export$3fc4fcb674af9bce = ()=>{
    const { edition: edition, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isEligibleUser = edition === (0, $euL71.ConfluenceEdition).FREE && isLoggedIn;
    return isEligibleUser;
};
module.exports["useIsStorageEnforcementEligible"] = $2f3a7af74886cca0$export$3fc4fcb674af9bce;

});

parcelRegister("cLhhP", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $ff89d2fd8e30c2ae$var$initialState = {
    isActive: false,
    source: ''
};
const $ff89d2fd8e30c2ae$var$NAME = 'BLOCK_CREATE_MODAL_STORE';
const $ff89d2fd8e30c2ae$var$BlockCreateModalStore = (0, $1P1Tu.createStore)({
    name: $ff89d2fd8e30c2ae$var$NAME,
    initialState: $ff89d2fd8e30c2ae$var$initialState,
    actions: {
        showBlockCreateModal: (source)=>({ setState: setState })=>{
                setState({
                    isActive: true,
                    source: source
                });
            },
        onBlockCreateModalClose: ()=>({ setState: setState })=>{
                setState({
                    isActive: false,
                    source: ''
                });
            }
    }
});
const $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc = (0, $9zUhf.createHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
const $ff89d2fd8e30c2ae$export$d0e21e34c085fe56 = (0, $9zUhf.createActionsHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
module.exports["useBlockCreateModalStore"] = $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc;
module.exports["useBlockCreateModalActions"] = $ff89d2fd8e30c2ae$export$d0e21e34c085fe56;

});

parcelRegister("7xVCs", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $T1bCI = parcelRequire("T1bCI");

class $3c23582ca65aa05a$export$90a06df90d015db9 extends (0, $T1bCI.Container) {
    scrollToCurrentPage() {
        this.setState({
            scrollToCurrent: true
        });
    }
    clearScrollTo() {
        this.setState({
            scrollToCurrent: false
        });
    }
    setHighlightPagesIds(pageIds) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(this.state.highlightPagesIds, pageIds)) this.setState({
            highlightPagesIds: pageIds
        });
    }
    clearHighlightedPages() {
        this.setHighlightPagesIds([]);
    }
    setForceFetchPageId(pageId) {
        this.setState({
            forceFetchPageId: pageId
        });
    }
    clearForceFetch() {
        this.setForceFetchPageId(null);
    }
    setOptimisticDeleteId(pageId) {
        this.setState({
            optimisticDeletePageId: pageId
        });
    }
    clearOptimisticDeleteId() {
        this.setOptimisticDeleteId(null);
    }
    setIsEditingTitleId(contentId) {
        return this.setState({
            editingTitle: {
                contentId: contentId
            }
        });
    }
    // This is for content types such as folders that do not have a create content url
    // Instead, we allow naming the content inside the page tree immediately after creation
    forceFetchWithInlineRename(forceFetchId, contentId) {
        this.setState({
            forceFetchPageId: forceFetchId,
            editingTitle: {
                contentId: contentId,
                isNewContent: true
            },
            scrollToPageId: contentId
        });
    }
    clearScrollToPageId() {
        this.setState({
            scrollToPageId: null
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            highlightPagesIds: [],
            forceFetchPageId: null,
            optimisticDeletePageId: null,
            scrollToCurrent: false,
            scrollToPageId: null,
            editingTitle: {
                contentId: null
            }
        };
    }
}
module.exports["PageTreeStateUpdater"] = $3c23582ca65aa05a$export$90a06df90d015db9;

});

parcelRegister("6adZX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $059c9f3c8066ba5d$var$initialState = {
    openFlyoutId: null // Keeps track of the currently open flyout by its menuId
};
const $059c9f3c8066ba5d$export$3d79379112bcd772 = (0, $1P1Tu.createStore)({
    name: 'FlyoutStore',
    initialState: $059c9f3c8066ba5d$var$initialState,
    actions: {
        openFlyout: (menuId)=>({ setState: setState })=>{
                setState({
                    openFlyoutId: menuId
                });
            },
        closeFlyout: (menuId = null)=>({ setState: setState, getState: getState })=>{
                if (!menuId || menuId === getState().openFlyoutId) setState({
                    openFlyoutId: null
                });
            }
    }
});
const $059c9f3c8066ba5d$export$377168f986312a4 = (0, $9zUhf.createHook)($059c9f3c8066ba5d$export$3d79379112bcd772, {
    selector: (state, menuId)=>state.openFlyoutId === menuId
});
const $059c9f3c8066ba5d$export$3f64b5809402b3ff = (menuId)=>{
    const [isFlyoutOpen, flyoutActions] = $059c9f3c8066ba5d$export$377168f986312a4(menuId);
    const openFlyout = (0, $42omo.useCallback)(()=>flyoutActions.openFlyout(menuId), [
        flyoutActions,
        menuId
    ]);
    const closeFlyout = (0, $42omo.useCallback)(()=>flyoutActions.closeFlyout(menuId), [
        flyoutActions,
        menuId
    ]);
    return {
        isFlyoutOpen: isFlyoutOpen,
        openFlyout: openFlyout,
        closeFlyout: closeFlyout
    };
};
const $059c9f3c8066ba5d$export$285f2f1642666795 = (0, $9zUhf.createActionsHook)($059c9f3c8066ba5d$export$3d79379112bcd772);
module.exports["useIsFlyoutOpen"] = $059c9f3c8066ba5d$export$377168f986312a4;
module.exports["useFlyout"] = $059c9f3c8066ba5d$export$3f64b5809402b3ff;
module.exports["useFlyoutActions"] = $059c9f3c8066ba5d$export$285f2f1642666795;

});

parcelRegister("cbBHq", function(module, exports) {
/* eslint-disable @typescript-eslint/consistent-type-imports */ 
var $42omo = parcelRequire("42omo");


var $lvOsp = parcelRequire("lvOsp");


var $2PxwR = parcelRequire("2PxwR");


var $6gwjd = parcelRequire("6gwjd");

const $0b3da77a55c8d66c$export$47d6a944ca09299 = ()=>{
    const [preloadSmartCreationModalQuery] = (0, $lvOsp.useLazyQueryInterop)((0, $6gwjd.default), {
        __callerPackage__: "@confluence/smart-create"
    });
    return (0, $42omo.useCallback)(()=>{
        preloadSmartCreationModalQuery();
        (0, $2PxwR.LazyConfluenceSmartCreationModal).preload();
    }, [
        preloadSmartCreationModalQuery
    ]);
};
module.exports["usePreloadSmartCreationModal"] = $0b3da77a55c8d66c$export$47d6a944ca09299;

});

parcelRegister("2PxwR", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c156286aa1d634b0$export$116ded32e65c3603 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "4mwBk",
    name: "LazyConfluenceSmartCreationModal",
    loader: async ()=>(await (parcelRequire("3XoBF"))).ConfluenceSmartCreationModal
});
module.exports["LazyConfluenceSmartCreationModal"] = $c156286aa1d634b0$export$116ded32e65c3603;

});

parcelRegister("3XoBF", function(module, exports) {

let $2e19f8257714587c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2e19f8257714587c$var$load("7PNQN"),
    $2e19f8257714587c$var$load("41wXF"),
    $2e19f8257714587c$var$load("zSp86"),
    $2e19f8257714587c$var$load("b9CA3"),
    $2e19f8257714587c$var$load("2YffH"),
    $2e19f8257714587c$var$load("ijNBa"),
    $2e19f8257714587c$var$load("hGJ7X"),
    $2e19f8257714587c$var$load("kkxT0"),
    $2e19f8257714587c$var$load("xu7ej"),
    $2e19f8257714587c$var$load("iQ4FP"),
    $2e19f8257714587c$var$load("3EXzu"),
    $2e19f8257714587c$var$load("blwYk"),
    $2e19f8257714587c$var$load("czd3n"),
    $2e19f8257714587c$var$load("dDDwq"),
    $2e19f8257714587c$var$load("89QMy"),
    $2e19f8257714587c$var$load("2wRqX"),
    $2e19f8257714587c$var$load("50D4z"),
    $2e19f8257714587c$var$load("j9Q0e"),
    $2e19f8257714587c$var$load("9K6Rh"),
    $2e19f8257714587c$var$load("jlCbV"),
    $2e19f8257714587c$var$load("kdQwx"),
    $2e19f8257714587c$var$load("4Jyg5"),
    $2e19f8257714587c$var$load("gnDXu"),
    $2e19f8257714587c$var$load("dMkP5"),
    $2e19f8257714587c$var$load("gBO6y"),
    $2e19f8257714587c$var$load("32eEQ"),
    $2e19f8257714587c$var$load("b11Cj"),
    $2e19f8257714587c$var$load("7bkye"),
    $2e19f8257714587c$var$load("9anPW"),
    $2e19f8257714587c$var$load("fAtWn"),
    $2e19f8257714587c$var$load("iPYAE"),
    $2e19f8257714587c$var$load("c9xEe"),
    $2e19f8257714587c$var$load("csAUX"),
    $2e19f8257714587c$var$load("kQSfw"),
    $2e19f8257714587c$var$load("8PzH3"),
    $2e19f8257714587c$var$load("2jJ1i"),
    $2e19f8257714587c$var$load("bd77Q"),
    $2e19f8257714587c$var$load("dDyu2"),
    $2e19f8257714587c$var$load("3K1dc"),
    $2e19f8257714587c$var$load("8EEwj"),
    $2e19f8257714587c$var$load("b2FtX"),
    $2e19f8257714587c$var$load("c0JsV"),
    $2e19f8257714587c$var$load("h3ABO"),
    $2e19f8257714587c$var$load("gXO4B"),
    $2e19f8257714587c$var$load("7nhGH"),
    $2e19f8257714587c$var$load("aMRFX"),
    $2e19f8257714587c$var$load("396ld"),
    $2e19f8257714587c$var$load("6wr18"),
    $2e19f8257714587c$var$load("j168w"),
    $2e19f8257714587c$var$load("2wyaQ"),
    $2e19f8257714587c$var$load("9DBoM"),
    $2e19f8257714587c$var$load("ffEVr"),
    $2e19f8257714587c$var$load("a0cZb"),
    $2e19f8257714587c$var$load("RXMWr"),
    $2e19f8257714587c$var$load("hhss7"),
    $2e19f8257714587c$var$load("Wowvf"),
    $2e19f8257714587c$var$load("1F7LX"),
    $2e19f8257714587c$var$load("hXbzh"),
    $2e19f8257714587c$var$load("jnVKv"),
    $2e19f8257714587c$var$load("7EorR"),
    $2e19f8257714587c$var$load("bgHzk"),
    $2e19f8257714587c$var$load("fQKYr")
]).then(()=>parcelRequire('6CLTo'));

});

parcelRegister("6gwjd", function(module, exports) {
/**
 * @generated SignedSource<<aed928c86f10a4e4f6955f6a921227cd>>
 * @relayHash e04a1fbd9772100897718d8eb52d327f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 29e075973424046eb1776b14978c687f77f381ef1355bfdb4ef0a4005920d641
const $7b2c6142b984d24d$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "ConfluenceSmartCreationModalQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "ConfluenceSmartCreationModalQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "e04a1fbd9772100897718d8eb52d327f",
            "id": "29e075973424046eb1776b14978c687f77f381ef1355bfdb4ef0a4005920d641",
            "metadata": {},
            "name": "ConfluenceSmartCreationModalQuery",
            "operationKind": "query",
            "text": "query ConfluenceSmartCreationModalQuery{user:confluence_atlassianUser(current:true){id,title}}"
        }
    };
}();
$7b2c6142b984d24d$var$node.hash = "b82822dc05785ac3b5e50c2feec2f4f2";
var $7b2c6142b984d24d$export$2e2bcd8739ae039 = $7b2c6142b984d24d$var$node;
module.exports["default"] = $7b2c6142b984d24d$export$2e2bcd8739ae039;

});

parcelRegister("lfBMY", function(module, exports) {
var $93e6e1e47a4562a8$export$64e79c67b77e1326 = /*#__PURE__*/ function(OperationTypes) {
    OperationTypes["USE"] = "use";
    OperationTypes["LIMITED_USE"] = "limited_use";
    OperationTypes["EXTERNAL_COLLABORATOR_USE"] = "external_collaborator_use";
    OperationTypes["CREATE"] = "create";
    OperationTypes["READ"] = "read";
    OperationTypes["UPDATE"] = "update";
    OperationTypes["DELETE"] = "delete";
    OperationTypes["COPY"] = "copy";
    OperationTypes["MOVE"] = "move";
    OperationTypes["EXPORT"] = "export";
    OperationTypes["ARCHIVE"] = "archive";
    OperationTypes["PURGE"] = "purge";
    OperationTypes["PURGE_VERSION"] = "purge_version";
    OperationTypes["ADMINISTER"] = "administer";
    OperationTypes["RESTORE"] = "restore";
    OperationTypes["CREATE_SPACE"] = "create_space";
    OperationTypes["RESTRICT_CONTENT"] = "restrict_content";
    OperationTypes["CLEAR_PERMISSIONS"] = "clear_permissions";
    return OperationTypes;
}({});
module.exports["OperationTypes"] = $93e6e1e47a4562a8$export$64e79c67b77e1326;

});

parcelRegister("2wo33", function(module, exports) {

var $cFXjQ = parcelRequire("cFXjQ");


var $9Z22p = parcelRequire("9Z22p");


var $jMyy4 = parcelRequire("jMyy4");


var $c0rhi = parcelRequire("c0rhi");


var $63cta = parcelRequire("63cta");


var $5rZJf = parcelRequire("5rZJf");

const $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    const permittedOperations = operationCheckResult?.content?.nodes?.[0]?.operations ?? [];
    const targetContentType = !!contentType ? contentType : operationCheckResult?.content?.nodes?.[0]?.type;
    if (!targetContentType) return false;
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === targetContentType);
};
const $fec7e6ab8c349d98$export$9df6fd1dd45ee771 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    // prettier-ignore
    const permittedOperations = operationCheckResult?.space?.operations ?? [];
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === contentType);
};
const $fec7e6ab8c349d98$export$e1260b60fe3f2784 = async ({ contentId: contentId, operation: operation, contentType: contentType })=>{
    const contentOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        query: (0, $63cta.ContentOperationsQuery),
        variables: {
            contentId: contentId
        },
        __callerPackage__: "@confluence/entity-operations"
    });
    return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: contentOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$bcbdef0ac5f1ac47 = async ({ spaceKey: spaceKey, operation: operation, contentType: contentType })=>{
    const spaceOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        query: (0, $5rZJf.SpaceOperationsQuery),
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "@confluence/entity-operations"
    });
    return $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: spaceOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$301dbe403ac05dd5 = ({ contentId: contentId, operation: operation, contentType: contentType, status: status })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $9Z22p.default), {
        variables: {
            contentId: contentId,
            status: status
        },
        skip: !contentId,
        __callerPackage__: "@confluence/entity-operations"
    });
    if (!contentId) return false;
    if (graphQLResult?.data) return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return undefined;
};
const $fec7e6ab8c349d98$export$1fefcc1c89f32022 = ({ spaceKey: spaceKey, operation: operation, contentType: contentType })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $cFXjQ.default), {
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "@confluence/entity-operations"
    });
    // Only show the publish button if the user has permission to update (edit) this content.
    let canPerformOperation = undefined;
    if (graphQLResult?.data) canPerformOperation = $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return [
        canPerformOperation,
        graphQLResult
    ];
};
module.exports["canPerformSpaceOperation"] = $fec7e6ab8c349d98$export$9df6fd1dd45ee771;
module.exports["useCanPerformContentOperation"] = $fec7e6ab8c349d98$export$301dbe403ac05dd5;
module.exports["useCanPerformSpaceOperation"] = $fec7e6ab8c349d98$export$1fefcc1c89f32022;

});

parcelRegister("cFXjQ", function(module, exports) {
/**
 * @generated SignedSource<<247131d79908e150d144b65bd18338c4>>
 * @relayHash 66373ccec9c74286b704fa866e6f85ed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b
const $718578d961a6d231$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "66373ccec9c74286b704fa866e6f85ed",
            "id": "1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b",
            "metadata": {},
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersSpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$718578d961a6d231$var$node.hash = "cc953c6fb5811bde7a3b5ed25712839f";
var $718578d961a6d231$export$2e2bcd8739ae039 = $718578d961a6d231$var$node;
module.exports["default"] = $718578d961a6d231$export$2e2bcd8739ae039;

});

parcelRegister("9Z22p", function(module, exports) {
/**
 * @generated SignedSource<<a98ec14c52d173566241d54d72eed0e4>>
 * @relayHash 74ad4c4ef681c6629c8477bfc21dc6ca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58
const $16467728a654d6f6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "74ad4c4ef681c6629c8477bfc21dc6ca",
            "id": "e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58",
            "metadata": {},
            "name": "entityOperationsHelpersContentOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$16467728a654d6f6$var$node.hash = "a2091cf4018c51963a252c5d39ee0cbc";
var $16467728a654d6f6$export$2e2bcd8739ae039 = $16467728a654d6f6$var$node;
module.exports["default"] = $16467728a654d6f6$export$2e2bcd8739ae039;

});

parcelRegister("63cta", function(module, exports) {

var $8r0lJ = parcelRequire("8r0lJ");

const $bc89d0f4a052c761$export$a42cd9ccc4f06e9e = (0, $8r0lJ.default);
module.exports["ContentOperationsQuery"] = $bc89d0f4a052c761$export$a42cd9ccc4f06e9e;

});

parcelRegister("8r0lJ", function(module, exports) {
/**
 * @generated SignedSource<<8e9cb6fd76c3c39141d1214b5e844944>>
 * @relayHash afd2c148a694798349dbf7c95e9faf5e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a
const $9494deed8cae7257$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "afd2c148a694798349dbf7c95e9faf5e",
            "id": "e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a",
            "metadata": {},
            "name": "ContentOperationsQuery",
            "operationKind": "query",
            "text": "query ContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$9494deed8cae7257$var$node.hash = "ab356c29a3f1071c83869406e4056f82";
var $9494deed8cae7257$export$2e2bcd8739ae039 = $9494deed8cae7257$var$node;
module.exports["default"] = $9494deed8cae7257$export$2e2bcd8739ae039;

});

parcelRegister("5rZJf", function(module, exports) {

var $3QLqz = parcelRequire("3QLqz");

const $8e7057c5d2ae7999$export$636a01496687d185 = (0, $3QLqz.default);
module.exports["SpaceOperationsQuery"] = $8e7057c5d2ae7999$export$636a01496687d185;

});

parcelRegister("3QLqz", function(module, exports) {
/**
 * @generated SignedSource<<c3ea92623b4eef102f52ae11931592ca>>
 * @relayHash 5ff0445d5306228126745d8454e82696
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6
const $5b7055a8a77b29df$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5ff0445d5306228126745d8454e82696",
            "id": "b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6",
            "metadata": {},
            "name": "SpaceOperationsQuery",
            "operationKind": "query",
            "text": "query SpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$5b7055a8a77b29df$var$node.hash = "c0226693d03f6d30e3056758ad9ba59d";
var $5b7055a8a77b29df$export$2e2bcd8739ae039 = $5b7055a8a77b29df$var$node;
module.exports["default"] = $5b7055a8a77b29df$export$2e2bcd8739ae039;

});

parcelRegister("hEnjc", function(module, exports) {

let $cd9840baec83cbc8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cd9840baec83cbc8$var$load("7gkvG"),
    $cd9840baec83cbc8$var$load("aMRFX"),
    $cd9840baec83cbc8$var$load("396ld"),
    $cd9840baec83cbc8$var$load("hXbzh"),
    $cd9840baec83cbc8$var$load("6wr18"),
    $cd9840baec83cbc8$var$load("loo2r"),
    $cd9840baec83cbc8$var$load("iAqyW"),
    $cd9840baec83cbc8$var$load("3CBDb"),
    $cd9840baec83cbc8$var$load("lnk1B"),
    $cd9840baec83cbc8$var$load("7PNQN"),
    $cd9840baec83cbc8$var$load("4hsy8"),
    $cd9840baec83cbc8$var$load("gy5DL"),
    $cd9840baec83cbc8$var$load("gbDLp"),
    $cd9840baec83cbc8$var$load("8YSo7"),
    $cd9840baec83cbc8$var$load("hOaAV"),
    $cd9840baec83cbc8$var$load("lFAez"),
    $cd9840baec83cbc8$var$load("1qlDN"),
    $cd9840baec83cbc8$var$load("1yVM6"),
    $cd9840baec83cbc8$var$load("4NdV5"),
    $cd9840baec83cbc8$var$load("cEqm7"),
    $cd9840baec83cbc8$var$load("6XCf4"),
    $cd9840baec83cbc8$var$load("36QeB"),
    $cd9840baec83cbc8$var$load("3KVI3"),
    $cd9840baec83cbc8$var$load("9DBoM"),
    $cd9840baec83cbc8$var$load("ffEVr"),
    $cd9840baec83cbc8$var$load("jLwPS"),
    $cd9840baec83cbc8$var$load("9IMTL"),
    $cd9840baec83cbc8$var$load("aRRyd"),
    $cd9840baec83cbc8$var$load("zSp86"),
    $cd9840baec83cbc8$var$load("kuFG2"),
    $cd9840baec83cbc8$var$load("7tgvK"),
    $cd9840baec83cbc8$var$load("g0OKa"),
    $cd9840baec83cbc8$var$load("hhss7"),
    $cd9840baec83cbc8$var$load("Wowvf"),
    $cd9840baec83cbc8$var$load("daX4F"),
    $cd9840baec83cbc8$var$load("7EorR"),
    $cd9840baec83cbc8$var$load("4Dabn")
]).then(()=>parcelRequire('7yriZ'));

});

parcelRegister("9x2sR", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $3hoG4 = parcelRequire("3hoG4");


var $3654r = parcelRequire("3654r");


var $eLJ8w = parcelRequire("eLJ8w");


var $8njHX = parcelRequire("8njHX");


var $fDC7w = parcelRequire("fDC7w");

const $a9268ffbf811ea39$var$listItemStyles = {
    root: "_10m98stt"
};
const $a9268ffbf811ea39$var$LinkMenuItemNoRef = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0, forwardedRef)=>{
    const $ = (0, $frIzR.c)(26);
    const { testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, actionsOnHover: actionsOnHover, isSelected: isSelected, onClick: onClick, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator } = t0;
    const itemRef = (0, $42omo.useRef)(null);
    const t1 = isSelected ?? false;
    let t2;
    if ($[0] !== t1) {
        t2 = {
            elementRef: itemRef,
            isSelected: t1
        };
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    (0, $fDC7w.useScrollMenuItemIntoView)(t2);
    const t3 = listItemRef ?? null;
    let t4;
    if ($[2] !== t3) {
        t4 = (0, $3654r.default)([
            itemRef,
            t3
        ]);
        $[2] = t3;
        $[3] = t4;
    } else t4 = $[3];
    const ref = t4;
    let t5;
    if ($[4] !== actions || $[5] !== actionsOnHover || $[6] !== children || $[7] !== description || $[8] !== dropIndicator || $[9] !== elemAfter || $[10] !== elemBefore || $[11] !== forwardedRef || $[12] !== hasDragIndicator || $[13] !== href || $[14] !== interactionName || $[15] !== isContentTooltipDisabled || $[16] !== isDragging || $[17] !== isSelected || $[18] !== onClick || $[19] !== target || $[20] !== testId || $[21] !== visualContentRef) {
        t5 = /*#__PURE__*/ $42omo.createElement((0, $8njHX.MenuItemBase), {
            testId: testId,
            description: description,
            actions: actions,
            elemAfter: elemAfter,
            elemBefore: elemBefore,
            href: href,
            target: target,
            actionsOnHover: actionsOnHover,
            isSelected: isSelected,
            onClick: onClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator
        }, children);
        $[4] = actions;
        $[5] = actionsOnHover;
        $[6] = children;
        $[7] = description;
        $[8] = dropIndicator;
        $[9] = elemAfter;
        $[10] = elemBefore;
        $[11] = forwardedRef;
        $[12] = hasDragIndicator;
        $[13] = href;
        $[14] = interactionName;
        $[15] = isContentTooltipDisabled;
        $[16] = isDragging;
        $[17] = isSelected;
        $[18] = onClick;
        $[19] = target;
        $[20] = testId;
        $[21] = visualContentRef;
        $[22] = t5;
    } else t5 = $[22];
    let t6;
    if ($[23] !== ref || $[24] !== t5) {
        t6 = /*#__PURE__*/ $42omo.createElement((0, $eLJ8w.ListItem), {
            ref: ref,
            xcss: $a9268ffbf811ea39$var$listItemStyles.root
        }, t5);
        $[23] = ref;
        $[24] = t5;
        $[25] = t6;
    } else t6 = $[25];
    return t6;
} : ({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, actionsOnHover: actionsOnHover, isSelected: isSelected, onClick: onClick, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const itemRef = (0, $42omo.useRef)(null);
    (0, $fDC7w.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: isSelected ?? false
    });
    const ref = (0, $42omo.useMemo)(()=>{
        return (0, $3654r.default)([
            itemRef,
            listItemRef ?? null
        ]);
    }, [
        itemRef,
        listItemRef
    ]);
    return /*#__PURE__*/ $42omo.createElement((0, $eLJ8w.ListItem), {
        ref: ref,
        xcss: $a9268ffbf811ea39$var$listItemStyles.root
    }, /*#__PURE__*/ $42omo.createElement((0, $8njHX.MenuItemBase), {
        testId: testId,
        description: description,
        actions: actions,
        elemAfter: elemAfter,
        elemBefore: elemBefore,
        href: href,
        target: target,
        actionsOnHover: actionsOnHover,
        isSelected: isSelected,
        onClick: onClick,
        ref: forwardedRef,
        visualContentRef: visualContentRef,
        interactionName: interactionName,
        isContentTooltipDisabled: isContentTooltipDisabled,
        isDragging: isDragging,
        hasDragIndicator: hasDragIndicator,
        dropIndicator: dropIndicator
    }, children));
};
const $a9268ffbf811ea39$export$d2cad7a1cce7b35f = (0, $3hoG4.default)($a9268ffbf811ea39$var$LinkMenuItemNoRef);
module.exports["LinkMenuItem"] = $a9268ffbf811ea39$export$d2cad7a1cce7b35f;

});

parcelRegister("3hoG4", function(module, exports) {
$parcel$export(module.exports, "default", () => $b38c95e6dd3d3e2d$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $b38c95e6dd3d3e2d$export$2e2bcd8739ae039 = (0, $42omo.forwardRef);

});

parcelRegister("fDC7w", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");


var $6BXcn = parcelRequire("6BXcn");

function $4023ab33a3161118$var$scrollMenuItemIntoView(element) {
    /**
   * If [scrollIntoViewIfNeeded](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoViewIfNeeded) is available,
   * we are using it to scroll the element into view _in the center_ of the scroll container. Because it is a non-standard method
   * and not available on all browsers (currently not supported in Firefox), we are using it for progressive enhancement.
   *
   * Otherwise, we are falling back to [scrollIntoView](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView).
   */ const elementWithScrollMethod = element;
    if (typeof elementWithScrollMethod.scrollIntoViewIfNeeded === 'function') {
        elementWithScrollMethod.scrollIntoViewIfNeeded(true);
        return;
    }
    // JSDOM does not support scrollIntoView, so defensively using it (see https://github.com/jsdom/jsdom/issues/1695)
    element.scrollIntoView?.({
        // We are using `nearest` to prevent scrolling on user interaction when the menu item is already in view.
        block: 'nearest'
    });
}
const $4023ab33a3161118$export$2c52ec851fcc6058 = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useScrollMenuItemIntoView(t0) {
    const $ = (0, $frIzR.c)(6);
    const { elementRef: elementRef, isSelected: isSelected } = t0;
    const areAllAncestorsExpanded = (0, $6BXcn.useAreAllAncestorsExpanded)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            type: "waiting-to-be-selected-and-all-ancestors-expanded"
        };
        $[0] = t1;
    } else t1 = $[0];
    const waitingStateRef = (0, $42omo.useRef)(t1);
    let t2;
    let t3;
    if ($[1] !== areAllAncestorsExpanded || $[2] !== elementRef || $[3] !== isSelected) {
        t2 = ()=>{
            if (waitingStateRef.current.type === "waiting-to-be-selected-and-all-ancestors-expanded") {
                const shouldScroll = areAllAncestorsExpanded && isSelected;
                if (!shouldScroll) return;
                const element = elementRef.current;
                (0, $dRnqM.default)(element, "Element ref must be set");
                $4023ab33a3161118$var$scrollMenuItemIntoView(element);
                waitingStateRef.current.type = "waiting-to-be-unselected";
                return;
            }
            if (waitingStateRef.current.type === "waiting-to-be-unselected") {
                if (!isSelected) waitingStateRef.current.type = "waiting-to-be-selected-and-all-ancestors-expanded";
                return;
            }
        };
        t3 = [
            areAllAncestorsExpanded,
            elementRef,
            isSelected
        ];
        $[1] = areAllAncestorsExpanded;
        $[2] = elementRef;
        $[3] = isSelected;
        $[4] = t2;
        $[5] = t3;
    } else {
        t2 = $[4];
        t3 = $[5];
    }
    (0, $42omo.useEffect)(t2, t3);
} : function useScrollMenuItemIntoView({ elementRef: elementRef, isSelected: isSelected }) {
    const areAllAncestorsExpanded = (0, $6BXcn.useAreAllAncestorsExpanded)();
    const waitingStateRef = (0, $42omo.useRef)({
        type: 'waiting-to-be-selected-and-all-ancestors-expanded'
    });
    (0, $42omo.useEffect)(()=>{
        if (waitingStateRef.current.type === 'waiting-to-be-selected-and-all-ancestors-expanded') {
            const shouldScroll = areAllAncestorsExpanded && isSelected;
            if (!shouldScroll) return;
            const element = elementRef.current;
            (0, $dRnqM.default)(element, 'Element ref must be set');
            $4023ab33a3161118$var$scrollMenuItemIntoView(element);
            // Now that we are scrolled the menu item into view, we need to wait for the menu item to
            // be unselected before checking again.
            waitingStateRef.current.type = 'waiting-to-be-unselected';
            return;
        }
        if (waitingStateRef.current.type === 'waiting-to-be-unselected') {
            if (!isSelected) waitingStateRef.current.type = 'waiting-to-be-selected-and-all-ancestors-expanded';
            return;
        }
    }, [
        areAllAncestorsExpanded,
        elementRef,
        isSelected
    ]);
};
module.exports["useScrollMenuItemIntoView"] = $4023ab33a3161118$export$2c52ec851fcc6058;

});

parcelRegister("jh864", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $8njHX = parcelRequire("8njHX");


var $jvL0g = parcelRequire("jvL0g");

const $bf400a28e0f66299$export$6dc09b7c0ec1dfcd = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? (t0, forwardedRef)=>{
    const $ = (0, $frIzR.c)(24);
    const { testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, isDisabled: isDisabled, isSelected: isSelected, elemBefore: elemBefore, actionsOnHover: actionsOnHover, onClick: onClick, "aria-controls": ariaControls, "aria-expanded": ariaExpanded, "aria-haspopup": ariaHasPopup, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator } = t0;
    const t1 = isDisabled ? undefined : actions;
    const t2 = isDisabled ? undefined : actionsOnHover;
    let t3;
    if ($[0] !== ariaControls || $[1] !== ariaExpanded || $[2] !== ariaHasPopup || $[3] !== children || $[4] !== description || $[5] !== dropIndicator || $[6] !== elemAfter || $[7] !== elemBefore || $[8] !== forwardedRef || $[9] !== hasDragIndicator || $[10] !== interactionName || $[11] !== isContentTooltipDisabled || $[12] !== isDisabled || $[13] !== isDragging || $[14] !== isSelected || $[15] !== onClick || $[16] !== t1 || $[17] !== t2 || $[18] !== testId || $[19] !== visualContentRef) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8njHX.MenuItemBase), {
            testId: testId,
            description: description,
            elemAfter: elemAfter,
            elemBefore: elemBefore,
            isDisabled: isDisabled,
            actions: t1,
            actionsOnHover: t2,
            onClick: onClick,
            ariaControls: ariaControls,
            ariaExpanded: ariaExpanded,
            ariaHasPopup: ariaHasPopup,
            isSelected: isSelected,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator
        }, children);
        $[0] = ariaControls;
        $[1] = ariaExpanded;
        $[2] = ariaHasPopup;
        $[3] = children;
        $[4] = description;
        $[5] = dropIndicator;
        $[6] = elemAfter;
        $[7] = elemBefore;
        $[8] = forwardedRef;
        $[9] = hasDragIndicator;
        $[10] = interactionName;
        $[11] = isContentTooltipDisabled;
        $[12] = isDisabled;
        $[13] = isDragging;
        $[14] = isSelected;
        $[15] = onClick;
        $[16] = t1;
        $[17] = t2;
        $[18] = testId;
        $[19] = visualContentRef;
        $[20] = t3;
    } else t3 = $[20];
    let t4;
    if ($[21] !== listItemRef || $[22] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jvL0g.MenuListItem), {
            ref: listItemRef
        }, t3);
        $[21] = listItemRef;
        $[22] = t3;
        $[23] = t4;
    } else t4 = $[23];
    return t4;
} : ({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, isDisabled: isDisabled, isSelected: isSelected, elemBefore: elemBefore, actionsOnHover: actionsOnHover, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jvL0g.MenuListItem), {
        ref: listItemRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8njHX.MenuItemBase), {
        testId: testId,
        description: description,
        elemAfter: elemAfter,
        elemBefore: elemBefore,
        isDisabled: isDisabled,
        /**
     * Not passing `actions` and `actionsOnHover` to MenuItemBase when `isDisabled`,
     * so they aren't rendered in the disabled state.
     */ actions: isDisabled ? undefined : actions,
        actionsOnHover: isDisabled ? undefined : actionsOnHover,
        onClick: onClick,
        ariaControls: ariaControls,
        ariaExpanded: ariaExpanded,
        ariaHasPopup: ariaHasPopup,
        isSelected: isSelected,
        ref: forwardedRef,
        visualContentRef: visualContentRef,
        interactionName: interactionName,
        isContentTooltipDisabled: isContentTooltipDisabled,
        isDragging: isDragging,
        hasDragIndicator: hasDragIndicator,
        dropIndicator: dropIndicator
    }, children));
});
module.exports["ButtonMenuItem"] = $bf400a28e0f66299$export$6dc09b7c0ec1dfcd;

});

parcelRegister("6i41U", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $42omo = parcelRequire("42omo");


var $8x1Q3 = parcelRequire("8x1Q3");

/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $77954d5459a690cb$var$useRouterLink = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $42omo.useContext)((0, $8x1Q3.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
} : ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $42omo.useContext)((0, $8x1Q3.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $77954d5459a690cb$export$2e2bcd8739ae039 = $77954d5459a690cb$var$useRouterLink;
module.exports["default"] = $77954d5459a690cb$export$2e2bcd8739ae039;

});

parcelRegister("8x1Q3", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $830764d8fffe9f5a$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $42omo.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $830764d8fffe9f5a$var$RouterLinkProvider = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { routerLinkComponent: routerLinkComponent, children: children } = t0;
    let t1;
    if ($[0] !== routerLinkComponent) {
        t1 = {
            routerLinkComponent: routerLinkComponent
        };
        $[0] = routerLinkComponent;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($830764d8fffe9f5a$export$2931e0ee690eee88.Provider, {
            value: t1
        }, children);
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($830764d8fffe9f5a$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$830764d8fffe9f5a$export$2e2bcd8739ae039 = $830764d8fffe9f5a$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $830764d8fffe9f5a$export$2931e0ee690eee88;

});

parcelRegister("yuV6Z", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $378a693b2c26358e$export$ca6dda5263526f75 = '/gateway/api/emoji';
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
const $378a693b2c26358e$var$isServerEnvironment = ()=>false; // "1" true || "" false || undefined false
const $378a693b2c26358e$var$isClientEnvironment = ()=>!!window.__SSR_RENDERED__;
const $378a693b2c26358e$export$2e27ba8337eb718f = '/gateway/api/elements/emoji';
const $378a693b2c26358e$export$756c07819e5ddb69 = (cloudId, emojiId, scale)=>{
    const baseUrl = (0, $dh538.fg)('use-elements-stargate-emoji-path') ? $378a693b2c26358e$export$2e27ba8337eb718f : $378a693b2c26358e$export$ca6dda5263526f75;
    return `${baseUrl}/${cloudId}/${emojiId}/path?scale=${scale ?? 'MDPI'}`;
};
const $378a693b2c26358e$export$761bef4dd134445c = (params)=>{
    const { isSSR: isSSR, hasCloudId: hasCloudId, isGuestUser: isGuestUser } = params;
    const ssrEnabled = !!(isSSR && hasCloudId);
    // SSR Not Supported
    if (!ssrEnabled || isGuestUser) return false;
    // SSR For Logged in Users
    return true;
};
const $378a693b2c26358e$export$fc7d38d59502d4a6 = ({ onEmojiLoadSuccess: onEmojiLoadSuccess, onEmojiLoadFail: onEmojiLoadFail })=>{
    if (!onEmojiLoadSuccess && !onEmojiLoadFail) return undefined;
    return {
        onEmojiLoadSuccess: onEmojiLoadSuccess,
        onEmojiLoadFail: onEmojiLoadFail
    };
};
const $378a693b2c26358e$export$91e66df277b39831 = (emojiId)=>{
    const { id: id, shortName: shortName } = emojiId;
    const regexp = new RegExp(/:([^:]+):/g); // tests and takes the value between two colons
    if (id) return id;
    if (regexp.test(shortName)) return shortName.replaceAll(':', '');
    return shortName;
};
const $378a693b2c26358e$export$1dcae2834e6255a2 = (params)=>{
    // Feature enabled flags
    const isSSR = $378a693b2c26358e$var$isServerEnvironment() || $378a693b2c26358e$var$isClientEnvironment();
    const isGuestUser = !params.isLicensed || !params.isLoggedIn;
    // Transform parameters
    const cloudId = params?.cloudId ?? '';
    const userId = params?.userId ?? undefined;
    const disableUpload = params?.disableUpload;
    const emojiSSRConfig = params?.emojiSSRConfig ?? {};
    // Enable emoji ssr
    const useEmojiSSR = $378a693b2c26358e$export$761bef4dd134445c({
        isSSR: isSSR,
        hasCloudId: !!cloudId,
        isGuestUser: isGuestUser
    });
    // Default emoji SSR interface
    const emojiSSRConfigOverride = useEmojiSSR ? {
        optimisticImageApi: {
            getUrl: (emojiId)=>$378a693b2c26358e$export$756c07819e5ddb69(cloudId, $378a693b2c26358e$export$91e66df277b39831(emojiId))
        },
        ...emojiSSRConfig
    } : undefined;
    // Enable emoji load callbacks
    const emojiLoadCallbacks = $378a693b2c26358e$export$fc7d38d59502d4a6({
        onEmojiLoadSuccess: params?.onEmojiLoadSuccess,
        onEmojiLoadFail: params?.onEmojiLoadFail
    });
    return {
        cloudId: cloudId,
        userId: userId,
        disableUpload: disableUpload,
        ...useEmojiSSR && {
            emojiSSRConfig: emojiSSRConfigOverride
        },
        emojiLoadCallbacks: emojiLoadCallbacks
    };
};
module.exports["getOptimisticImageURL"] = $378a693b2c26358e$export$756c07819e5ddb69;
module.exports["getEmojiSSRSupport"] = $378a693b2c26358e$export$761bef4dd134445c;
module.exports["createEmojiProviderParameters"] = $378a693b2c26358e$export$1dcae2834e6255a2;

});

parcelRegister("aQZ08", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $lGgRw = parcelRequire("lGgRw");


var $inPa6 = parcelRequire("inPa6");


var $jmjWc = parcelRequire("jmjWc");


var $56QzY = parcelRequire("56QzY");


var $7zgzO = parcelRequire("7zgzO");


var $de2j9 = parcelRequire("de2j9");


var $ep3mz = parcelRequire("ep3mz");


var $7EIq6 = parcelRequire("7EIq6");


var $gsXbX = parcelRequire("gsXbX");

const $dc1ea4817175b6dd$export$e961788b96f97626 = ()=>{
    const $ = (0, $frIzR.c)(19);
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    let t0;
    if ($[0] !== createAnalyticsEvent || $[1] !== isOnEditRoute || $[2] !== isOpen || $[3] !== match?.name) {
        t0 = ()=>{
            setIsOpen(!isOpen);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "navigationItem",
                    actionSubjectId: "globalCreateContentPopover",
                    source: "globalNavigation",
                    attributes: {
                        selectedItemPageContext: match?.name,
                        navigationLayer: "global",
                        navigationContainer: "top",
                        navVersion: "4",
                        navdexPointType: (0, $56QzY.START),
                        isOnEditRoute: isOnEditRoute
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = isOnEditRoute;
        $[2] = isOpen;
        $[3] = match?.name;
        $[4] = t0;
    } else t0 = $[4];
    const onClick = t0;
    const { isCreateWhiteboardEnabled: isCreateWhiteboardEnabled, isCreateBlogEnabled: isCreateBlogEnabled, isCreateLiveDocEnabled: isCreateLiveDocEnabled, isCreateDatabaseEnabled: isCreateDatabaseEnabled, isCreateSmartLinkEnabled: isCreateSmartLinkEnabled, isCreateSlidesEnabled: isCreateSlidesEnabled } = (0, $7EIq6.useSpaceEnabledContentTypes)(spaceKey);
    let t1;
    if ($[5] !== isCreateBlogEnabled || $[6] !== isCreateDatabaseEnabled || $[7] !== isCreateLiveDocEnabled || $[8] !== isCreateSlidesEnabled || $[9] !== isCreateSmartLinkEnabled || $[10] !== isCreateWhiteboardEnabled) {
        t1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($dc1ea4817175b6dd$var$GlobalCreateContentPopoverMenuLoader, {
                closePopup: ()=>setIsOpen(false),
                isCreateBlogEnabled: isCreateBlogEnabled,
                isCreateLiveDocEnabled: isCreateLiveDocEnabled,
                isCreateWhiteboardEnabled: isCreateWhiteboardEnabled,
                isCreateDatabaseEnabled: isCreateDatabaseEnabled,
                isCreateSmartLinkEnabled: isCreateSmartLinkEnabled,
                isCreateSlidesEnabled: isCreateSlidesEnabled
            });
        $[5] = isCreateBlogEnabled;
        $[6] = isCreateDatabaseEnabled;
        $[7] = isCreateLiveDocEnabled;
        $[8] = isCreateSlidesEnabled;
        $[9] = isCreateSmartLinkEnabled;
        $[10] = isCreateWhiteboardEnabled;
        $[11] = t1;
    } else t1 = $[11];
    const popupContent = t1;
    let t2;
    if ($[12] !== onClick) {
        t2 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gsXbX.GlobalCreateContentButton), {
                onClick: onClick,
                triggerProps: triggerProps
            });
        $[12] = onClick;
        $[13] = t2;
    } else t2 = $[13];
    const popupTrigger = t2;
    let t3;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>setIsOpen(false);
        $[14] = t3;
    } else t3 = $[14];
    let t4;
    if ($[15] !== isOpen || $[16] !== popupContent || $[17] !== popupTrigger) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
            isOpen: isOpen,
            onClose: t3,
            placement: "bottom-start",
            content: popupContent,
            trigger: popupTrigger,
            testId: "create-content-popover",
            shouldRenderToParent: true
        });
        $[15] = isOpen;
        $[16] = popupContent;
        $[17] = popupTrigger;
        $[18] = t4;
    } else t4 = $[18];
    return t4;
};

const $dc1ea4817175b6dd$var$GlobalCreateContentPopoverMenuLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "5t0g-",
    name: "GlobalCreateContentPopoverMenuLoader",
    loader: async ()=>(await (parcelRequire("fZHGM"))).GlobalCreateContentPopoverMenu
});
module.exports["GlobalCreateContentPopover"] = $dc1ea4817175b6dd$export$e961788b96f97626;

});

parcelRegister("gsXbX", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $jmjWc = parcelRequire("jmjWc");


var $6PMed = parcelRequire("6PMed");








var $gMc0m = parcelRequire("gMc0m");

const $35d2916df5304fc4$export$feec4094f6279c08 = 1129;
const $35d2916df5304fc4$export$be58b4326e23250f = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _18u0r5cr",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $35d2916df5304fc4$export$bfe3a25e72ae6442 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1y3ozwfg _1qbpzwfg _7bqgzwfg _9kv71tcg _1i0i1tcg _1f1h1tcg _859hu2gc _1wkzu2gc _bgw9u2gc _1n3cidpf _113jidpf _1kzlidpf",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});



const $18414c638d573189$var$CreateButton = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "xnuWz",
    name: "CreateButton",
    loader: async ()=>(await (parcelRequire("j2wXr"))).CreateButton
});
const $18414c638d573189$var$i18n = (0, $aXWIB.defineMessages)({
    create: {
        id: "create-blank-fabric-page.create.content.popover.button",
        defaultMessage: "Create"
    },
    createContentLabel: {
        id: "create-blank-fabric-page.create.content.aria.label",
        defaultMessage: "Create content"
    }
});
const $18414c638d573189$export$256eebed8e934f30 = (createButtonTheme)=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...createButtonTheme.default,
                margin: 0,
                fontWeight: "var(--ds-font-weight-medium, 500)",
                ':hover': createButtonTheme.hover,
                ':focus': createButtonTheme.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && createButtonTheme.active
                }
            },
            spinnerStyles: spinnerStyles
        };
    };
const $18414c638d573189$export$dff01287f8ba179f = (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { triggerProps: triggerProps, onClick: onClick } = t0;
    const { ref: ref } = triggerProps;
    const preloadCreationMenuData = (0, $6PMed.usePreloadCreationMenuData)();
    let t1;
    if ($[0] !== onClick) {
        t1 = ()=>{
            onClick();
        };
        $[0] = onClick;
        $[1] = t1;
    } else t1 = $[1];
    const handleClick = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $18414c638d573189$var$i18n.create);
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== handleClick) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($18414c638d573189$var$CreateButton, {
            onClick: handleClick,
            testId: "create-content-popover-button"
        }, t2);
        $[3] = handleClick;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== preloadCreationMenuData || $[6] !== ref || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $35d2916df5304fc4$export$bfe3a25e72ae6442), {
            "data-vc": "create-content-button-wrapper",
            ref: ref,
            onMouseEnter: preloadCreationMenuData,
            onFocus: preloadCreationMenuData
        }, t3);
        $[5] = preloadCreationMenuData;
        $[6] = ref;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
};
module.exports["GlobalCreateContentButton"] = $18414c638d573189$export$dff01287f8ba179f;

});

parcelRegister("cDCEW", function(module, exports) {

var $frIzR = parcelRequire("frIzR");

/**
 * @generated SignedSource<<5db28364bb496e83ffa996cccacc8baa>>
 * @relayHash 6df3b61373374b3cf5fce7cb1a4ae00e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ea3599f53b3067003f1d16b483219ce64610129a2ca5eb30a7413f45d983d66a
const $3c9d02ac08c2414c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContextualCreateContentButtonQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContextualCreateContentButtonQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "6df3b61373374b3cf5fce7cb1a4ae00e",
            "id": "ea3599f53b3067003f1d16b483219ce64610129a2ca5eb30a7413f45d983d66a",
            "metadata": {},
            "name": "ContextualCreateContentButtonQuery",
            "operationKind": "query",
            "text": "query ContextualCreateContentButtonQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$3c9d02ac08c2414c$var$node.hash = "09e72f8536a752645e0ea9769800b50e";
var $3c9d02ac08c2414c$export$2e2bcd8739ae039 = $3c9d02ac08c2414c$var$node;



var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1qfLF = parcelRequire("1qfLF");


var $3gadb = parcelRequire("3gadb");


var $g5gZt = parcelRequire("g5gZt");


var $lfBMY = parcelRequire("lfBMY");


var $2wo33 = parcelRequire("2wo33");


var $b3j2Y = parcelRequire("b3j2Y");


var $jtuBN = parcelRequire("jtuBN");

const $6e1fd29dfbf932de$var$i18n = (0, $aXWIB.defineMessages)({
    simpleCreateLabel: {
        id: "create-blank-fabric-page.contextual-create.button.simple-create-label",
        defaultMessage: "Create"
    },
    simpleCreateLabelForTitle: {
        id: "create-blank-fabric-page.contextual-create.button.simple-create-label-for-title",
        defaultMessage: "Create child content for {pageTitle}"
    }
});
const $6e1fd29dfbf932de$var$canCreateContent = (data)=>{
    return (0, $2wo33.canPerformSpaceOperation)({
        operationCheckResult: data,
        operation: (0, $lfBMY.OperationTypes).CREATE,
        contentType: 'page'
    });
};
const $6e1fd29dfbf932de$export$e5aab90af54da00f = (isOpen)=>{
    return isOpen ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)";
};
const $6e1fd29dfbf932de$var$BaseIconButton = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, ref)=>{
    const $ = (0, $frIzR.c)(5);
    let props;
    if ($[0] !== t0) {
        const { isRootCreateButton: _isRootCreateButton, isOpen: _isOpen, ...t1 } = t0;
        props = t1;
        $[0] = t0;
        $[1] = props;
    } else props = $[1];
    let t1;
    if ($[2] !== props || $[3] !== ref) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            ...props,
            ref: ref
        });
        $[2] = props;
        $[3] = ref;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-unsafe-style-overrides -- To migrate as part of go/ui-styling-standard
const $6e1fd29dfbf932de$var$ContextualCreateButton = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? $6e1fd29dfbf932de$var$BaseIconButton : t2;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_147mbvz": (0, $7sObp.default)($6e1fd29dfbf932de$export$e5aab90af54da00f(__cmplp.isOpen))
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_1efsqup9",
                __cmplp.isRootCreateButton ? "_i2zu1q3r" : "_i2zu1kw7",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $6e1fd29dfbf932de$export$613f902834bf164 = (t0)=>{
    const $ = (0, $frIzR.c)(20);
    const { triggerProps: triggerProps, onClick: onClick, isContextualCreateFocused: isContextualCreateFocused, isOpen: isOpen, spaceKey: spaceKey, rootCreateButtonStyling: rootCreateButtonStyling, displayTitle: displayTitle } = t0;
    const intl = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] !== spaceKey) {
        t1 = {
            variables: {
                spaceKey: spaceKey
            }
        };
        $[0] = spaceKey;
        $[1] = t1;
    } else t1 = $[1];
    const { data: data, loading: loading, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $3c9d02ac08c2414c$export$2e2bcd8739ae039), t1);
    let t2;
    if ($[2] !== onClick) {
        t2 = (e)=>{
            onClick(e);
        };
        $[2] = onClick;
        $[3] = t2;
    } else t2 = $[3];
    const handleClick = t2;
    if (error && isOpen) {
        let t3;
        if ($[4] !== error) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            });
            $[4] = error;
            $[5] = t3;
        } else t3 = $[5];
        return t3;
    }
    const canCreate = data && $6e1fd29dfbf932de$var$canCreateContent(data);
    if (loading || !canCreate) return null;
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $6e1fd29dfbf932de$var$i18n.simpleCreateLabel);
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== intl || $[8] !== isContextualCreateFocused) {
        t4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
                color: isContextualCreateFocused ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)",
                label: intl.formatMessage($6e1fd29dfbf932de$var$i18n.simpleCreateLabel),
                size: "small"
            });
        $[7] = intl;
        $[8] = isContextualCreateFocused;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== displayTitle || $[11] !== intl) {
        t5 = displayTitle ? intl.formatMessage($6e1fd29dfbf932de$var$i18n.simpleCreateLabelForTitle, {
            pageTitle: displayTitle
        }) : intl.formatMessage($6e1fd29dfbf932de$var$i18n.simpleCreateLabel);
        $[10] = displayTitle;
        $[11] = intl;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== handleClick || $[14] !== isContextualCreateFocused || $[15] !== rootCreateButtonStyling || $[16] !== t4 || $[17] !== t5 || $[18] !== triggerProps) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: t3,
            position: "top",
            hideTooltipOnMouseDown: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6e1fd29dfbf932de$var$ContextualCreateButton, {
            ...triggerProps,
            id: "contextual-create-content-button",
            appearance: "subtle",
            icon: t4,
            label: t5,
            onClick: handleClick,
            testId: "contextual-create-content-button",
            isSelected: isContextualCreateFocused,
            isOpen: isContextualCreateFocused,
            isRootCreateButton: rootCreateButtonStyling
        }));
        $[13] = handleClick;
        $[14] = isContextualCreateFocused;
        $[15] = rootCreateButtonStyling;
        $[16] = t4;
        $[17] = t5;
        $[18] = triggerProps;
        $[19] = t6;
    } else t6 = $[19];
    return t6;
};
module.exports["contextualCreateContentIconSVGColor"] = $6e1fd29dfbf932de$export$e5aab90af54da00f;
module.exports["ContextualCreateContentButton"] = $6e1fd29dfbf932de$export$613f902834bf164;

});

parcelRegister("6PMed", function(module, exports) {

var $b8RlQ = parcelRequire("b8RlQ");


var $aAydK = parcelRequire("aAydK");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $d9tcB = parcelRequire("d9tcB");


var $eVXGa = parcelRequire("eVXGa");


var $lvOsp = parcelRequire("lvOsp");


var $9wGTI = parcelRequire("9wGTI");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");




const $bd992de7e8ae5757$var$usePreloadCreationMenuDataWhiteboardCreationPaywallContentToDisableQuery = (0, $aAydK.default);
const $bd992de7e8ae5757$var$RovoAgentPermissionsQuery = (0, $b8RlQ.default);
const $bd992de7e8ae5757$export$305839d0d8489bf4 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { edition: edition, cloudId: cloudId, isRovoLLMEnabled: isRovoLLMEnabled, accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isPremium = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const isAnonymousUser = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS || !isLoggedIn;
    const shouldPreloadAgentData = isRovoLLMEnabled && !isAnonymousUser && cloudId && (0, $9wGTI.fg)('cc_fd_agent_creation_connie_create_gate');
    const isAllowedToCreateWhiteboard = (0, $eVXGa.useIsAllowedToCreateWhiteboard)();
    const [preloadWhiteboardPaywallData] = (0, $lvOsp.useLazyQueryInterop)($bd992de7e8ae5757$var$usePreloadCreationMenuDataWhiteboardCreationPaywallContentToDisableQuery, {
        __callerPackage__: "@confluence/create-blank-fabric-page"
    });
    const [preloadAgentPermissionsData] = (0, $lvOsp.useLazyQueryInterop)($bd992de7e8ae5757$var$RovoAgentPermissionsQuery, {
        interopApolloAggClient: true,
        onCompleted: (data)=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: 'createContentPopover',
                    action: 'success',
                    actionSubject: 'studioPermissionsQuery',
                    actionSubjectId: 'createMenuPreloader',
                    attributes: {
                        isAbleToCreateAgents: data?.atlassianStudio_userSiteContext?.userPermissions?.isAbleToCreateAgents
                    }
                }
            }).fire();
        },
        onError: (error)=>{
            if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error) && ((0, $1uFM6.isUnauthorizedError)(error) || error?.message.includes('Failed to fetch'))) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                return;
            }
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: 'createContentPopover',
                    action: 'error',
                    actionSubject: 'studioPermissionsQuery',
                    actionSubjectId: 'createMenuPreloader',
                    attributes: {
                        errorMessage: error.message
                    }
                }
            }).fire();
        },
        __callerPackage__: "@confluence/create-blank-fabric-page"
    });
    const shouldPreloadPaywallData = isAllowedToCreateWhiteboard && !isPremium;
    return (0, $42omo.useCallback)(()=>{
        if (shouldPreloadPaywallData) preloadWhiteboardPaywallData();
        if (shouldPreloadAgentData) preloadAgentPermissionsData({
            variables: {
                cloudId: cloudId
            }
        });
    }, [
        preloadWhiteboardPaywallData,
        shouldPreloadPaywallData,
        preloadAgentPermissionsData,
        shouldPreloadAgentData,
        cloudId
    ]);
};
module.exports["usePreloadCreationMenuData"] = $bd992de7e8ae5757$export$305839d0d8489bf4;

});

parcelRegister("b8RlQ", function(module, exports) {
/**
 * @generated SignedSource<<d592328883ad2e06dccbcded16e9d8a3>>
 * @relayHash 18d5c1b8f0928a561df53ac8bc87a1fb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5a2603965d4bbb2306ec7b9390eef7cfab97424fdf5dd9757ff9593239ea648d
const $9ae901475af3b836$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "AtlassianStudioUserProductPermissions",
                "kind": "LinkedField",
                "name": "userPermissions",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isAbleToCreateAgents"
                    }
                ]
            }
        ],
        "type": "AtlassianStudioUserSiteContextOutput"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePreloadCreationMenuDataAgentPermissionsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "atlassianStudio_userSiteContext",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePreloadCreationMenuDataAgentPermissionsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "atlassianStudio_userSiteContext",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "18d5c1b8f0928a561df53ac8bc87a1fb",
            "id": "5a2603965d4bbb2306ec7b9390eef7cfab97424fdf5dd9757ff9593239ea648d",
            "metadata": {},
            "name": "usePreloadCreationMenuDataAgentPermissionsQuery",
            "operationKind": "query",
            "text": "query usePreloadCreationMenuDataAgentPermissionsQuery($cloudId:ID!){atlassianStudio_userSiteContext(cloudId:$cloudId){__typename,...on AtlassianStudioUserSiteContextOutput{userPermissions{isAbleToCreateAgents}}}}"
        }
    };
}();
$9ae901475af3b836$var$node.hash = "1b640a148257dd29856c8633ea3c743e";
var $9ae901475af3b836$export$2e2bcd8739ae039 = $9ae901475af3b836$var$node;
module.exports["default"] = $9ae901475af3b836$export$2e2bcd8739ae039;

});

parcelRegister("aAydK", function(module, exports) {
/**
 * @generated SignedSource<<246aece2820b13f49cde0598465fd381>>
 * @relayHash d464c5ce295068d47ccc0dcaf071b79b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cb7f849eb94b1fd84196d828e4039833ab7eb4b4aeb9e90b1cb11c693aac6752
const $3ee76ab31c862ca9$var$node = function() {
    var v0 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "contentType",
                    "value": "whiteboard"
                }
            ],
            "concreteType": "PaywallContentSingle",
            "kind": "LinkedField",
            "name": "paywallContentToDisable",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "deactivationIdentifier"
                },
                {
                    "kind": "ScalarField",
                    "name": "link"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ],
            "storageKey": "paywallContentToDisable(contentType:\"whiteboard\")"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "usePreloadCreationMenuDataWhiteboardCreationPaywallContentToDisableQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "usePreloadCreationMenuDataWhiteboardCreationPaywallContentToDisableQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "d464c5ce295068d47ccc0dcaf071b79b",
            "id": "cb7f849eb94b1fd84196d828e4039833ab7eb4b4aeb9e90b1cb11c693aac6752",
            "metadata": {},
            "name": "usePreloadCreationMenuDataWhiteboardCreationPaywallContentToDisableQuery",
            "operationKind": "query",
            "text": "query usePreloadCreationMenuDataWhiteboardCreationPaywallContentToDisableQuery{paywallContentToDisable(contentType:\"whiteboard\"){deactivationIdentifier,link,title}}"
        }
    };
}();
$3ee76ab31c862ca9$var$node.hash = "0ae29c21d88d7354f7898f5999535995";
var $3ee76ab31c862ca9$export$2e2bcd8739ae039 = $3ee76ab31c862ca9$var$node;
module.exports["default"] = $3ee76ab31c862ca9$export$2e2bcd8739ae039;

});


//# sourceMappingURL=CreateContentPopover.73ef9609.js.map
